import ChargeHelper from 'features/Charge/chargeHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';

DialogVoucherPartnerVehicleDetailView.propTypes = {
  item: PropTypes.object.isRequired,
  user: PropTypes.object,
  onCancel: PropTypes.func,
};

function DialogVoucherPartnerVehicleDetailView({ item, onDone, user }) {
  // MARK: ---- PROPERTIES ----
  const row = item;

  return (
    <div className="p-4">
      <div style={{ backgroundColor: AppColors.gray[100] }}>
        {UIHelper.buildSectionCard(
          <div
            className=""
            style={{
              backgroundColor: 'white',
              borderRadius: '5px',
              overflow: 'hidden',
            }}
          >
            {UIHelper.buildCardCellItem(
              'Biển số xe',
              row?.plate,
            )}
            {UIHelper.buildCardCellItem(
              'Khách hàng',
              row?.user?.fullname,
            )}
            {UIHelper.buildCardCellItem(
              'Trạng thái',
              <KTLabel
                text={ChargeHelper.Utils.getVehicleStatusName(row?.status)}
                isInline={true}
                size={KTLabelSize.medium}
                additionalClassName={`label-light-${ChargeHelper.Utils.getVehicleStatusColor(
                  row?.status
                )}`}
              />
            )}
            {UIHelper.buildCardCellItem(
              'Loại phương tiện',
              row?.vehicleType
                ? _.find(
                  ChargeHelper.Data.vehicleTypeOptions,
                  (item) => item.value === row?.vehicleType
                )?.name
                : '',
            )}
            {UIHelper.buildCardCellItem(
              'Hãng xe',
              row?.model?.brand?.name,
            )}
            {UIHelper.buildCardCellItem(
              'Dòng xe',
              row?.model?.name,
            )}
            {UIHelper.buildCardCellItem(
              'Số khung',
              row?.vinNumber,
              null,
              false
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default DialogVoucherPartnerVehicleDetailView;
